'use strict';

$(document).off('init.select2');
$(document).on('init.select2', function() {
    $.fn.select2.defaults.set('width', '100%');

    $.fn.select2 && $('[data-init-plugin="select2"]').each(function() {
        $(this).select2({
            minimumResultsForSearch: ($(this).attr('data-disable-search') == 'true' ? -1 : 1)
        }).on('select2-opening', function() {
            $.fn.scrollbar && $('.select2-results').scrollbar({
                ignoreMobile: false
            })
        });
    });
});
